import React from "react";

const DEFAULT_DEPARTMENTS = [
  { value: "", label: "All Departments" },
  { value: "Customer Service", label: "Customer Service" },
  { value: "Custom Order", label: "Custom Order" },
  { value: "Concierge", label: "Concierge" },
  { value: "Account Executive", label: "Account Executive" },
];

export default function GreatDepartmentFilter({
  value,
  onChange,
  className = "",
  disabled = false,
  options = null,
  id = "great-department-filter",
}) {
  const departments = options && options.length > 0 ? options : DEFAULT_DEPARTMENTS;
  return (
    <div className={`flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center ${className}`}>
      <label htmlFor={id} className="text-sm font-medium text-navy-700 dark:text-white whitespace-nowrap">
        Department
      </label>
      <select
        id={id}
        className={`w-full sm:w-60 px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:border-gray-600 ${
          disabled
            ? "cursor-not-allowed bg-gray-100 text-gray-500 dark:bg-navy-900 dark:text-gray-400"
            : "bg-white text-navy-700 dark:bg-navy-800 dark:text-white"
        }`}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        {departments.map((d) => (
          <option key={d.value || "all"} value={d.value}>
            {d.label}
          </option>
        ))}
      </select>
    </div>
  );
}
